import axiosInstance from "./axiosConfig";

// ================= BASIC REQUESTS =================

// GET
export const getRequest = (url, config = {}) => {
  return axiosInstance.get(url, config);
};

// POST
export const postRequest = (url, payload, config = {}) => {
  return axiosInstance.post(url, payload, config);
};

// PATCH
export const patchRequest = (url, payload, config = {}) => {
  return axiosInstance.patch(url, payload, config);
};

// DELETE
export const deleteRequest = (url, config = {}) => {
  return axiosInstance.delete(url, config);
};

// ================= NEWS APIs =================

// 🔹 Get news by language
export const getNewsByLanguage = (language) => {
  return getRequest(`/product/search?language=${language}`);
};

// 🔹 Universal filter (category / state / language)
export const getNewsByFilter = (params) => {
  return getRequest(`/product/search`, { params });
};



// MEDIA
export const getAllMedia = () => {
  return axiosInstance.get("/media");
};


// GALLERY
export const getAllGallery = () => {
  return axiosInstance.get("/gallery");
};
